import type { SVGProps } from "react";

const CoefficientsIcon = ({
  width = 30,
  height = 30,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M15 27.5c-5.303 0-7.955 0-9.602-1.83C3.75 23.838 3.75 20.891 3.75 15c0-5.893 0-8.839 1.648-10.67C7.045 2.5 9.697 2.5 15 2.5s7.955 0 9.602 1.83C26.25 6.162 26.25 9.108 26.25 15c0 5.892 0 8.839-1.648 10.67C22.956 27.5 20.303 27.5 15 27.5Z"
      opacity={0.5}
    />
    <path
      fill="#000"
      d="M18.75 7.5h-7.5c-.581 0-.872 0-1.11.064A1.875 1.875 0 0 0 8.814 8.89c-.064.238-.064.529-.064 1.11 0 .581 0 .872.064 1.11a1.875 1.875 0 0 0 1.326 1.326c.238.064.529.064 1.11.064h7.5c.581 0 .872 0 1.11-.064a1.875 1.875 0 0 0 1.326-1.326c.064-.238.064-.529.064-1.11 0-.581 0-.872-.064-1.11a1.875 1.875 0 0 0-1.326-1.326c-.238-.064-.529-.064-1.11-.064ZM10 17.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM10 22.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM15 17.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM15 22.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM20 17.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM20 22.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
    />
  </svg>
);
export default CoefficientsIcon;
